import { applicationModuleRegistry } from '../application-module-registry.js';
import { getMainRoute, mapRoutes } from './application-routes.js';
import { getAvailableModules } from './available-modules.js';
/**
 * Retrieves the application module with the specified id.
 *
 * @param id - The id of the module to retrieve.
 *
 * @throws Throws an error if the module is not available.
 */
function getModule(id) {
    const availableModules = getAvailableModules();
    const module = applicationModuleRegistry.get(id);
    if (!availableModules.has(module.id)) {
        throw new Error(`[oswald:get-module]: Module ${id} is not available.`);
    }
    return module;
}
/**
 * Retrieves the route associated with the specified application module, taking into account any mapped routes and the main route.
 *
 * @param module - The application module for which to retrieve the route.
 */
function getModuleRoute(module) {
    const mappedRoutes = mapRoutes(module.id, module.route, module.routes);
    const mainRoute = getMainRoute(mappedRoutes);
    if (mainRoute) {
        return mainRoute.completeRoute ?? mainRoute.route;
    }
    return module.route;
}
export { getModule, getModuleRoute, };
//# sourceMappingURL=module.js.map